import {memo, useEffect} from "react";
import {ReactSVG} from "react-svg";
import useWindowSize from "Hooks/useWindowSize";
import {useUserBalance} from "../../../Hooks/Queries/User/useUserBalance";

export const WithBalance = memo(function BankCardsComponent({
                                                              setPaymentMethod,
                                                              paymentRef,
                                                              paymentMethod,
                                                              cardPrice,
                                                              hasEnoughBalance,
                                                              isMob = false,
                                                              handleModalStates,
                                                              fromProfile = false,
                                                            }: {
  setPaymentMethod?: any;
  isMob?: boolean;
  paymentRef?: any;
  paymentMethod?: any;
  cardPrice: any;
  hasEnoughBalance: boolean,
  fromProfile?: boolean;
  handleModalStates?: any
}) {

  const {userBalance, refetchBalance} = useUserBalance(true);

  const {width} = useWindowSize();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refetchBalance();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);


  return (
      <div ref={paymentRef} className={""}>
        <div
            className={`${
                !fromProfile && "p-[0px] pt-10"
            } flex flex-col gap-12 bg-[#fff] rounded-[12px] md:p-0 ${isMob ? "mt-6" : "mt-0"}`}>
          <div>

            <div className={"flex items-center justify-between mb-4"}>
              <h2 className="text-[18px] font-bold">გადახდა ბალანსით</h2>
              <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleModalStates('balance', true)
                  }}
                  className={"mr-1 rounded-[12px] bg-green-100 flex items-center px-4 py-[10px] cursor-pointer"}>
                <ReactSVG src="/images/icons/add.svg" className={`mr-1`}/>
                <p className={"text-[#FFF] font-demi text-sm"}>
                  შევსება
                </p>
              </button>
            </div>

            <div className="bg-gray-30 p-5 rounded-[12px] flex flex-col gap-6 cursor-pointer"
                 onClick={() =>
                     setPaymentMethod({
                       method: "balance",
                     })
                 }
            >
              <div
                  className={""}>
                <div className={"flex justify-between items-center"}>
                  <div className={"flex items-center"}>
                    <div className={"bg-[#FFF] flex items-center justify-center w-10 h-10 rounded-xl mr-1.5"}>
                      <ReactSVG src="/images/icons/lariblack.svg" className={""}/>
                    </div>
                    <p className={"text-sm font-bold text-blackPrimary-100"}>
                      {"ბალანსი :".toUpperCase()}
                    </p>
                    <span className={"text-sm flex items-center font-bold ml-1"}>
                      {userBalance?.amount?.toFixed(2)}
                      <ReactSVG
                          className={""}
                          src="/images/icons/lariSmall.svg"/>
                    </span>
                  </div>

                  <div className={"flex items-center font-medium"}>
                    {paymentMethod?.method == "balance" ? (
                        <button
                            className="w-[20px] h-[20px] bg-[#fff] border-[6px] border-solid border-green-100 rounded-[50%]"/>
                    ) : (
                        <button
                            className="w-[20px] h-[20px] bg-blackPrimary-10 border-[#070A1433] border-[1px] rounded-[50%]"/>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {!hasEnoughBalance && <span className={"mt-2 text-raspberry-100 text-sm flex items-center"}>
                     <ReactSVG src="/images/icons/warning.svg" className={"mr-2"}/>
                    თქვენ არ გაქვთ საკმარისი ბალანსი, გთხოვთ შეავსოთ</span>}

      </div>
  );
});
